import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { appRoutes } from 'app/app-routes';
import { User, UserActionCode, useUsersAddFavoriteMutation, useUsersRemoveFavoriteMutation } from 'graphql/generated';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { cacheActions } from 'redux/cache.slice';

type Props = {
  value: boolean;
  toggleFn?: (value: boolean) => void;
  user?: User;
  listingId: string;
  includeLabel?: boolean;
  deleteMode?: boolean;
  readOnly?: boolean;
};

const favoriteColor = '#ec4855';

const FavoriteIcons = (props: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [addFavorite] = useUsersAddFavoriteMutation();
  const [removeFavorite] = useUsersRemoveFavoriteMutation();

  const setFavorite = async () => {
    if (props.readOnly) return;

    if (!props.user) {
      dispatch(cacheActions.loginNavigate(true));
      navigate(appRoutes.login);
      return;
    }
    if (!props.value) {
      const { data } = await addFavorite({
        variables: { usersAddFavoriteId: props.user!.id, listingId: props.listingId },
      });
      if (data?.usersAddFavorite && data.usersAddFavorite.code === UserActionCode.success) {
        const { __typename, ...updatedUser } = data.usersAddFavorite.user!;
        dispatch(cacheActions.user(updatedUser));
        if (props.toggleFn) props.toggleFn(true);
      }
    } else {
      const { data } = await removeFavorite({
        variables: { usersRemoveFavoriteId: props.user!.id, listingId: props.listingId },
      });
      if (data?.usersRemoveFavorite && data.usersRemoveFavorite.code === UserActionCode.success) {
        const { __typename, ...updatedUser } = data.usersRemoveFavorite.user!;
        dispatch(cacheActions.user(updatedUser));
        if (props.toggleFn) props.toggleFn(false);
      }
    }
  };

  return (
    <>
      {(!props.deleteMode || props.value) && (
        <IconButton
          color="primary"
          sx={{ padding: 0 }}
          aria-label="favorite"
          component="span"
          onClick={() => setFavorite()}
        >
          {props.value ? (
            <>
              {props.deleteMode ? (
                <DeleteForeverIcon sx={{ fontSize: '24px' }} />
              ) : (
                <>
                  <FavoriteIcon sx={{ fontSize: '24px', color: favoriteColor }} />
                  {props.includeLabel && (
                    <Typography color="primary" sx={{ paddingLeft: '4px' }} fontSize={14} variant="body1">
                      Saved
                    </Typography>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <FavoriteBorderIcon sx={{ fontSize: '24px' }} />
              {props.includeLabel && (
                <Typography color="primary" sx={{ paddingLeft: '4px' }} fontSize={14} variant="body1">
                  Save
                </Typography>
              )}
            </>
          )}
        </IconButton>
      )}
    </>
  );
};

export default FavoriteIcons;
